
/*export const URL = "https://www.sfctickets.com/webapi/";
export const UPLOADS="https://www.sfctickets.com/uploads/";*/
/*export const URL = "http://192.168.1.25/sfcsite/webapi/";
export const UPLOADS="http://192.168.1.25/sfcsite/uploads/";*/

export const EBKEY = "FKE1NJNYXU";
export const URL = "https://sfcticket.in/webapi/";
export const UPLOADS="https://sfcticket.in/uploads/";